<!-- Specific Course -->
<section>

    <!-- Page Title -->
    <div class="text-center">
        <h1>Housing Provider Education</h1>
    </div>
    <hr class="line">
    <br>
    <!-- Continue Course -->
    <div class="container content-box continue-bar" (click)="continueCourse()">
        <circle-progress [percent]="progress" [radius]="80" [outerStrokeWidth]="14" [innerStrokeWidth]="7" [outerStrokeColor]="this.outerColor" [innerStrokeColor]="this.innerColor" [animation]="true" [animationDuration]="300"></circle-progress>

        <!-- Course not started-->
        <h1 *ngIf="course.furthestModuleID === 0 && course.furthestPageID === 0">Begin Course</h1>

        <!-- Course started -->
        <h1 *ngIf="course.furthestModuleID < modules.length && (course.furthestModuleID > 0 || course.furthestPageID > 0)">Continue Course</h1>

        <!-- Course finished-->
        <div *ngIf="course.furthestModuleID >= modules.length && user.ageUnder18 !== true" class="add-property-tab">
          <h1>Add/View Properties you Own/Manage</h1>
          <h5>Adding properties you do not own is a violation of the EULA and can result in financial penality</h5>
        </div>
    </div>
</section>

<!-- Completed Modules -->
<section>
    <div class="module-title">
        <h1>Modules</h1>
    </div>
    <hr class="line">
    <br>
    <!-- Module Tabs -->
    <div class="container modules text-center">

        <!-- Module -->
        <div class="content-box module-tab" *ngFor="let module of modules; index as i" [routerLink]="['./m', i + 1]"
          [class.disabled]="course.furthestModuleID < i">
            <h3>{{i + 1}}. {{module.title}}</h3>
        </div>
    </div>
</section>

<!-- Properties Tab -->
<section class="properties-section" *ngIf="user.ageUnder18 !== true">

    <!-- Title -->
    <div class="module-title">
        <h1>Properties</h1>
    </div>
    <hr class="line">
    <br>

    <!-- Properties -->
    <div class="container content-box continue-bar" [class.disabled]="course.furthestModuleID < modules.length" [routerLink]="'./properties'">


        <!-- Course not complete -->
        <h1 *ngIf="course.furthestModuleID < modules.length">Complete Course to add your properties</h1>

        <!-- Course complete -->
        <div *ngIf="course.furthestModuleID >= modules.length" class="add-property-tab">
          <h1>Add/View Properties you Own/Manage</h1>
          <h5>Adding properties you do not own is a violation of the EULA and can result in financial penality</h5>
        </div>
    </div>
</section>
